export default __webpack_public_path__ + "static/time-mobile-b8c63c62200ba256c3559542fef197bd.gif";